"use client";
import React, { useState } from "react";
import { Switch2 } from "../../design2/components/ButtonSwitch";
import HeroPage3 from "../components/HeroPage3";
import CustomSelect from "../../design1/components/ui/form/CustomSelect";
import { BranchSummaryCard } from "../../design1/Branches";
import { useStaffDetails } from "src/app/lib/useStaffDetails";
import { useParams } from "next/navigation";
import { EmailIcon, CallIcon, toRecord } from "../../design2/StaffPage2";
import Link from "next/link";
import { About } from "../../design1/About1";
import CardGrid from "../../../CardGrid";

import { Design3Card } from "../components/Highlighted";
import StyledWraper from "../components/StyledWraper";
import Image from "next/image";
import { PropertyType, StaffStats } from "src/types";
import NoSearchCriteria from "src/app/components/ui/NoSearchCriteria";
const StaffPage3 = () => {
  const [activeBranch, setActiveBranch] = useState<1 | 2>(1); // Default is 1
  const options = [
    { value: "all", label: "All listings" },
    { value: "rent", label: "For Rent" },
    { value: "sale", label: "For Sale" },
    { value: "shortlet", label: "Short let" },
  ];

  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const handleSelect = (value: string) => {

    setSelectedValue(value); // Important to update state
  };

  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const { data: staff } = useStaffDetails(toNum);

  return (
    <section className="w-full max-w-full overflow-clip">
      <HeroPage3 className="!pb-12">
        <div
          className="text-center
         sm:flex-col sm:items-center  pt-10 text-white flex items-end gap-14"
        >
          <div className="img rounded-xl bg-themeColor-70 max-w-full border overflow-hidden border-white">
            <Image
              width={220}
              height={200}
              className="max-h-[220px] border-[2px] border-white object-cover w-[220px]"
              src={staff?.picture as string} // Switch image
              alt="user image"
            />
          </div>
          <div className="flex flex-col text-left">
            <h1 className="text-4xl text-white font-semibold mt-4">
              {staff?.name}
            </h1>
            <h2 className="h4 mb-5"> {staff?.position}</h2>
            <div className="flex flex-wrap gap-6">
              <Link
                href={`tel:${staff?.phone}`}
                className="hover:underline text-xl flex gap-2"
              >
                <CallIcon /> {staff?.phone}
              </Link>
              <Link
                href={`mailto:${staff?.email}`}
                className="hover:underline text-xl flex gap-2"
              >
                <EmailIcon /> {staff?.email}
              </Link>
            </div>
          </div>
        </div>
      </HeroPage3>
      <div className="wrapper py-10">
        <div className="first gap-10 flex mb-6 justify-between">
          <Switch2
            button1Text="Overview"
            button2Text="Listing"
            activeState={activeBranch}
            onSwitch={(newState) => setActiveBranch(newState)}
          />
          <div
            className={`p-2 border border-themeColor ${
              activeBranch === 1 && "invisible"
            } rounded-md`}
          >
            <span className={`${activeBranch === 2 ? "visible" : "invisible"}`}>
              <CustomSelect
                options={options}
                value={selectedValue}
                onChange={setSelectedValue}
                handleSelect={handleSelect}
                placeholder="All listings"
              />
            </span>
          </div>
        </div>
        {activeBranch === 1 ? (
          <FirstTab
            desc={staff?.about_staff as string}
            name={staff?.name || "No name provided"}
            values={staff?.stats as StaffStats}
          />
        ) : (
          <SecondTab
            selectValue={selectedValue as string}
            listings={staff?.staffListing as PropertyType[]}
          />
        )}
      </div>
    </section>
  );
};
export default StaffPage3;

<div>
  <div></div>
</div>;

const FirstTab: React.FC<{
  name: string;
  desc: string;
  values: StaffStats;
}> = ({ name, desc, values }) => {
  return (
    <div className="grid-container">
      <StyledWraper className="h-max">
        <About
          className="!mb-0"
          remove
          title={`About ${name}`}
          desc={desc || `No description available for ${name} at the moment.`}
        />
      </StyledWraper>

      <StyledWraper className="!h-max">
        <BranchSummaryCard
          {...{ title: "About Staff", values: toRecord(values) }}
        />
      </StyledWraper>
    </div>
  );
};
const SecondTab = ({
  listings,
  selectValue,
}: {
  listings: PropertyType[];
  selectValue: string;
}) => {
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  // Define if user is filtering on something other than 'all' or empty
  const isFiltering = selectValue && selectValue !== "all";

  // If filtered out (filter not rent and not demo)
  const isFilteredOut = selectValue !== "rent" && !isDemo;

  // When filtering but filtered out or no results
  if (isFiltering && (isFilteredOut || !listings?.length)) {
    return <NoSearchCriteria />;
  }

  // When not filtering and no listings at all
  if (!isFiltering && (!listings || listings.length === 0)) {
    return (
      <div>
        <p>No listings available right now.</p>
        {/* Optionally show popular listings or info */}
      </div>
    );
  }

  // Default: show listings
  return (
    <div>
      <CardGrid>
        {listings.map((item, index) => (
          <Design3Card key={item.id ?? index} {...item} />
        ))}
      </CardGrid>
    </div>
  );
};
